import { BackstageOverrides } from '@backstage/core-components';
import { alpha, Theme } from '@mui/material/styles';
import { getSurfaceBorder, getSurfaceColor, radii } from '../tokens';

export const styledMuiCard = (theme: Theme): BackstageOverrides['MuiCard'] => ({
  root: {
    backgroundColor: getSurfaceColor(theme, 'raised'),
    backgroundImage: `linear-gradient(180deg, ${alpha(
      theme.palette.common.white,
      theme.palette.mode === 'dark' ? 0.02 : 0.28,
    )} 0%, transparent 100%)`,
    border: `1px solid ${getSurfaceBorder(theme)}`,
    borderRadius: radii.lg,
    boxShadow: 'none',
    overflow: 'hidden',
  },
});
